import { useDispatch } from 'react-redux'
import { logout, login } from '../../../store/user'
import { useEffect, useState } from 'react'
import { useUser, useAuth, useClerk } from '@clerk/clerk-react'

export const useAuthManagement = () => {
  const dispatch = useDispatch()
  const { user } = useUser()
  const { getToken, isLoaded, isSignedIn } = useAuth()
  const { signOut } = useClerk()
  const [isAuthComplete, setIsAuthComplete] = useState(false)

  useEffect(() => {
    async function fetchData() {
      if (isSignedIn && isLoaded && user?.id) {
        try {
          const userId = user.id
          const token = await getToken()
          localStorage.setItem('token', token)
          localStorage.setItem('username', userId)
          // Set up global logout function for request error handling
          window.dispatchLogout = () => {
            localStorage.removeItem('token')
            localStorage.removeItem('username')
            dispatch(logout())
            window.location.href = '/auth'
          }

          window.refreshAuthToken = async () => {
            try {
              const newToken = await getToken()
              if (newToken) {
                localStorage.setItem('token', newToken)
                return true
              }
              return false
            } catch (error) {
              console.error('Failed to refresh auth token:', error)
              return false
            }
          }

          dispatch(
            login({ userId, userEmail: user.primaryEmailAddress?.emailAddress })
          )
          setIsAuthComplete(true)
        } catch (error) {
          console.error('Error during authentication setup:', error)
          setIsAuthComplete(false)
        }
      } else if (isLoaded && !isSignedIn) {
        console.log('User not signed in or auth not loaded yet')
        setIsAuthComplete(false)
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        delete window.dispatchLogout
        delete window.refreshAuthToken
      }
    }

    fetchData()
  }, [dispatch, user, getToken, isLoaded, isSignedIn])

  const logOutFn = () => {
    dispatch(logout())
  }

  const handleLogout = async () => {
    console.log('logging out #########')
    try {
      // Clear localStorage and Redux state first
      localStorage.removeItem('token')
      localStorage.removeItem('username')

      // Clear gallery state cache so next login starts at level 1
      try {
        const keysToRemove = []
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i)
          if (key && key.includes('gallery_state')) {
            keysToRemove.push(key)
          }
        }
        keysToRemove.forEach(key => sessionStorage.removeItem(key))
      } catch (_) {
        // ignore sessionStorage errors
      }

      logOutFn()
      // sign out from Clerk
      await signOut()
    } catch (error) {
      console.error('Error during logout:', error)
      // Fallback navigation if Clerk signOut fails
      window.location.href = '/auth'
    }
  }

  // Handle exit to LG TV
  const handleExitToLG = () => {
    console.log('exiting to LG TV')
    // LG TV specific logic would go here
  }

  // Handle hamburger menu actions
  const handleHamburger = e => {
    e.stopPropagation()
    e.preventDefault()
  }

  const handleSignInHamburger = e => {
    e.stopPropagation()
    e.preventDefault()
  }

  return {
    // State
    user,
    isAuthComplete,

    // Authentication functions
    handleLogout,
    handleExitToLG,
    handleHamburger,
    handleSignInHamburger,

    // Utilities
    logOutFn
  }
}
